import {
    useMutation,
    useQueryClient,
    UseMutationResult,
} from '@tanstack/react-query'
import { updateSubscriptions } from '../../services/groupsServices'
import { GlobalSubscriptions } from '../../components/UserGroups/interfaces'

export const useUpdateSubscriptions = (
    userGroupId: string,
    orgId: string,
): UseMutationResult<
    Awaited<ReturnType<typeof updateSubscriptions>>,
    Error,
    GlobalSubscriptions
> => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (subscriptions: GlobalSubscriptions) => {
            return updateSubscriptions(userGroupId, subscriptions)
        },
        //client side optimistic update
        onMutate: (subscriptions: GlobalSubscriptions) => {
            queryClient.setQueryData(
                ['userGroupSubscriptions', userGroupId, orgId],
                subscriptions,
            )
        },
        // //refetch attributes after mutation,
        // onSettled: () =>
        //     queryClient.invalidateQueries({
        //         queryKey: ['userGroupSubscriptions', userGroupId, orgId],
        //     }),
    })
}
